import React, { Component } from 'react';
import {baseUrl} from '../../url';
import moment from 'moment';

class FBC extends Component{
    constructor(){
        super()
        this.state = {
            type: 'bloodcount',
            date: '',
            haemoglobin: '',
            haematocrit: '',
            wbc_total: '',
            platelet: '',
            esr: '',
            mchc: '',
            mch: '',
            mcv: '',
            rbc: '',
            rdw: '',
            pdw: '',
            neutrophil: '',
            lymphocytes: '',
            mixed_field_differential: '',
            mpv: '',
            p_lcr: '',
            mxd: '',
            lymph:'',
            mid: '',
            gran: '',
            response: true,
            success: false,
        }
    }
    handleChange = (e) => {
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });

        if(e.target.name === 'date'){
            let date  = moment(e.target.value).format('YYYY-MM-DD HH:mm:ss')
            this.setState({
                date
            })
        }
    }
    close = () => {
        setTimeout(() => { 
            this.props.handleClose();
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {
            type,
            date,
            haemoglobin,
            haematocrit,
            wbc_total,
            platelet,
            esr,
            mchc,
            mch,
            rbc,
            rdw,
            pdw,
            neutrophil,
            lymphocytes,
            mixed_field_differential,
            mpv,
            mcv,
            p_lcr,
            mxd,
            lymph,
            mid,
            gran,
        } = this.state;

        if(!date){
            this.setState({
                dateError: 'Enter a valid date'
            })
        }
        if(!haemoglobin){
            this.setState({
                haemoglobinError: 'Enter a valid value'
            })
        }
        if(!haematocrit){
            this.setState({
                haematocritError: 'Enter a valid value'
            })
        }
        if(!wbc_total){
            this.setState({
                wbc_totalError: 'Enter a valid value'
            })
        }
        if(!platelet){
            this.setState({
                plateletError: 'Enter a valid value'
            })
        }
        if(!esr){
            this.setState({
                esrError: 'Enter a valid value'
            })
        }
        if(!mchc){
            this.setState({
                mchcError: 'Enter a valid value'
            })
        }
        if(!mch){
            this.setState({
                mchError: 'Enter a valid value'
            })
        }
        if(!rbc){
            this.setState({
                rbcError: 'Enter a valid value'
            })
        }
        if(!rdw){
            this.setState({
                rdwError: 'Enter a valid value'
            })
        }
        if(!pdw){
            this.setState({
                pdwError: 'Enter a valid value'
            })
        }
        if(!neutrophil){
            this.setState({
                neutrophilError: 'Enter a valid value'
            })
        }
        if(!lymphocytes){
            this.setState({
                lymphocytesError: 'Enter a valid value'
            })
        }
        if(!mixed_field_differential){
            this.setState({
                mixed_field_differentialError: 'Enter a valid value'
            })
        }
        if(!mpv){
            this.setState({
                mpvError: 'Enter a valid value'
            })
        }
        if(!mcv){
            this.setState({
                mcvError: 'Enter a valid value'
            })
        }
        if(!p_lcr){
            this.setState({
                p_lcrError: 'Enter a valid value'
            })
        }
        if(!mxd){
            this.setState({
                mxdError: 'Enter a valid value'
            })
        }
        if(!lymph){
            this.setState({
                lymphError: 'Enter a valid value'
            })
        }
        if(!mid){
            this.setState({
                midError: 'Enter a valid value'
            })
        }
        if(!gran){
            this.setState({
                granError: 'Enter a valid value'
            })
        }
        if( type &&
            date &&
            haemoglobin &&
            haematocrit &&
            wbc_total &&
            platelet &&
            esr &&
            mchc &&
            mch &&
            rbc &&
            rdw &&
            pdw &&
            neutrophil &&
            lymphocytes &&
            mixed_field_differential &&
            mpv &&
            mcv &&
            p_lcr &&
            mxd &&
            lymph &&
            mid &&
            gran
        ){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            const id = localStorage.getItem('user_id');
            let retries = 0;
            let entry = {
                type,
                'treatment_date': date,
                haemoglobin,
                haematocrit,
                wbc_total,
                platelet,
                esr,
                mchc,
                mch,
                rbc,
                rdw,
                pdw,
                neutrophil,
                lymphocytes,
                mixed_field_differential,
                mpv,
                mcv,
                p_lcr,
                mxd,
                lymph,
                mid,
                gran
            };

            fetch(`${baseUrl}/admin/patients/tests/${id}`,{
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       }, () => {
                           this.props.hideField();
                           this.props.refresh();
                           this.close();
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        return(
            <React.Fragment>
                {
                    !this.state.success && 
                    <React.Fragment>
                        <label>
                            Date test was taken
                            <input type="date" onChange={this.handleChange} name="date" className={this.state.dateError ? 'error-input' : ''}/>
                            <span className="error-text">{this.state.dateError}</span>
                        </label>
                        <label>
                            Haemoglobin (Hb)
                            <input type="number" onChange={this.handleChange} name="haemoglobin" className={this.state.haemoglobinError ? 'error-input' : ''}/>
                            <span>g/L</span>
                            <span className="regular">Normal Range 140-175</span>
                            <span className="error-text">{this.state.haemoglobinError}</span>
                        </label>
                        <label>
                            Haematocrit (PCV)
                            <input type="number" step='0.01' onChange={this.handleChange} name="haematocrit" className={this.state.haematocritError ? 'error-input' : ''}/>
                            <span>L/L</span>
                            <span className="regular">Normal Range 0.41-0.50</span>
                            <span className="error-text">{this.state.haematocritError}</span>
                        </label>
                        <label>
                            WBC Total
                            <input type="number" step='0.1' onChange={this.handleChange} name="wbc_total" className={this.state.wbc_totalError ? 'error-input' : ''}/>
                            <span>10<sup>9</sup>/L</span>
                            <span className="regular">Normal Range 4.5-11</span>
                            <span className="error-text">{this.state.wbc_totalError}</span>
                        </label>
                        <label>
                            Platelet
                            <input type="number" onChange={this.handleChange} name="platelet" className={this.state.plateletError ? 'error-input' : ''}/>
                            <span>10<sup>9</sup>/L</span>
                            <span className="regular">Normal Range 150-350</span>
                            <span className="error-text">{this.state.plateletError}</span>
                        </label>
                        <label>
                            ESR
                            <input type="number"  onChange={this.handleChange} name="esr" className={this.state.esrError ? 'error-input' : ''}/>
                            <span>mm/hr</span>
                            <span className="regular">Normal Range 3-7 mm/hr Westergren</span>
                            <span className="error-text">{this.state.esrError}</span>
                        </label>
                        <label>
                            MCHC
                            <input type="number" onChange={this.handleChange} name="mchc" className={this.state.mchcError ? 'error-input' : ''}/>
                            <span>g/L</span>
                            <span className="regular">Normal Range 330-370</span>
                            <span className="error-text">{this.state.mchcError}</span>
                        </label>
                        <label>
                            MCH
                            <input type="number" onChange={this.handleChange} name="mch" className={this.state.mchError ? 'error-input' : ''}/>
                            <span>pg/Cell</span>
                            <span className="regular">Normal Range 26-34</span>
                            <span className="error-text">{this.state.mchError}</span>
                        </label>
                        <label>
                            MCV
                            <input type="number" onChange={this.handleChange} name="mcv" className={this.state.mcvError ? 'error-input' : ''}/>
                            <span>/fL</span>
                            <span className="regular">Normal Range 80-100</span>
                            <span className="error-text">{this.state.mcvError}</span>
                        </label>
                        <label>
                            RBC
                            <input type="number" step='0.1' onChange={this.handleChange} name="rbc" className={this.state.rbcError ? 'error-input' : ''}/>
                            <span>10<sup>12</sup>/L</span>
                            <span className="regular">Normal Range 3.9-5.5</span>
                            <span className="error-text">{this.state.rbcError}</span>
                        </label>
                        <label>
                            RDW
                            <input type="number" step='0.1' onChange={this.handleChange} name="rdw" className={this.state.rdwError ? 'error-input' : ''}/>
                            <span>%</span>
                            <span className="regular">Normal Range 11.6-14.0</span>
                            <span className="error-text">{this.state.rdwError}</span>
                        </label>
                        <label>
                            PDW
                            <input type="number" step='0.1' onChange={this.handleChange} name="pdw" className={this.state.pdwError ? 'error-input' : ''}/>
                            <span>fl</span>
                            <span className="regular">Normal Range 9.4-18.1</span>
                            <span className="error-text">{this.state.pdwError}</span>
                        </label>
                        <label>
                            Neutrophil (Poly)
                            <input type="number" onChange={this.handleChange} name="neutrophil" className={this.state.neutrophilError ? 'error-input' : ''}/>
                            <span>%</span>
                            <span className="regular">Normal Range 40-70%</span>
                            <span className="error-text">{this.state.neutrophilError}</span>
                        </label>
                        <label>
                            Lymphocytes
                            <input type="number" onChange={this.handleChange} name="lymphocytes" className={this.state.lymphocytesError ? 'error-input' : ''}/>
                            <span>%</span>
                            <span className="regular">Normal Range 20-50%</span>
                            <span className="error-text">{this.state.lymphocytesError}</span>
                        </label>
                        <label>
                            Mixed Field Differential
                            <input type="number" onChange={this.handleChange} name="mixed_field_differential" className={this.state.mixed_field_differentialError ? 'error-input' : ''}/>
                            <span>%</span>
                            <span className="regular">Normal Range 2-20%</span>
                            <span className="error-text">{this.state.mixed_field_differentialError}</span>
                        </label>
                        <label>
                            MPV
                            <input type="number" step='0.1' onChange={this.handleChange} name="mpv" className={this.state.mpvError ? 'error-input' : ''}/>
                            <span>/fL</span>
                            <span className="regular">Normal Range 8.4-9.8</span>
                            <span className="error-text">{this.state.mpvError}</span>
                        </label>
                        <label>
                            P-LCR
                            <input type="number" step='0.1' onChange={this.handleChange} name="p_lcr" className={this.state.p_lcrError ? 'error-input' : ''}/>
                            <span>%</span>
                            <span className="regular">Normal Range 6.8-20.6</span>
                            <span className="error-text">{this.state.p_lcrError}</span>
                        </label>
                        <label>
                            MXD
                            <input type="number" onChange={this.handleChange} name="mxd" className={this.state.mxdError ? 'error-input' : ''}/>
                            {/* <span>%</span> */}
                            {/* <span className="regular">Normal Range 6.8-20.6</span> */}
                            <span className="error-text">{this.state.mxdError}</span>
                        </label>
                        <label>
                            Lymph#
                            <input type="number" step='0.1' onChange={this.handleChange} name="lymph" className={this.state.lymphError ? 'error-input' : ''}/>
                            <span>10<sup>3</sup>/uL</span>
                            <span className="regular">Normal Range 2.3</span>
                            <span className="error-text">{this.state.lymphError}</span>
                        </label>
                        <label>
                            Mid#
                            <input type="number" step='0.1' onChange={this.handleChange} name="mid" className={this.state.midError ? 'error-input' : ''}/>
                            <span>10<sup>3</sup>/uL</span>
                            <span className="regular">Normal Range 0.3</span>
                            <span className="error-text">{this.state.midError}</span>
                        </label>
                        <label>
                            Gran#
                            <input type="number" step='0.1' onChange={this.handleChange} name="gran" className={this.state.granError ? 'error-input' : ''}/>
                            <span>10<sup>3</sup>/uL</span>
                            <span className="regular">Normal Range 0.6</span>
                            <span className="error-text">{this.state.granError}</span>
                        </label>
                        <button onClick={this.handleSubmit}>
                            Save
                            {
                                !this.state.response &&
                                <i className="fa fa-spinner fa-pulse fa-fw" />
                            }
                        </button>
                    </React.Fragment>
                }
                {
                    this.state.success &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </div>
                        <p><small>{this.state.message}</small></p>
                    </div> 
                }    
            </React.Fragment>
        )
    }
}

export default FBC;


// WEBPACK FOOTER //
// ./src/components/patientProfile/testForms/fbc.js